<template>
         <!-- min-h-full h-screen -->
         <div class="  w-full">
             <Card class="main-card">
                 <template #content>
                     
                     <TabView @tab-change="fetchData">
                         <TabPanel header="Orders">
                             <OnlyOrdersComponent ></OnlyOrdersComponent>
                         
                        </TabPanel>
                        <TabPanel header="Items">  
                                <OrderItemsComponent :key="itemsComponentKey" ></OrderItemsComponent>
                        </TabPanel>

                        <TabPanel header="Set Location">                        
                            <SetLocationComponent :key="itemsWithoutLocationKey" ></SetLocationComponent>
                        </TabPanel>
                 </TabView>
             </template>
         </Card>

         </div>



</template>

<script>
import Card from 'primevue/card';
import { deptOrders } from '@/services/api/v2/apis';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { useDeptPoStore } from '@/stores/deptPoStore';
import SetLocationComponent from './setLocationComponent.vue';
import OrderItemsComponent from './orderItemsComponent.vue';
import OnlyOrdersComponent from './onlyOrdersComponent.vue';

export default {
    name: 'OrdersList',
    components: {
        Card,
        TabView,
        TabPanel,
        SetLocationComponent,
        OrderItemsComponent,
        OnlyOrdersComponent,
    },
    
    data(){
        return{
            selectedFy:null,
            // globalConstants,
            queryText:null,
            poDate:null,
            orderStatusOptions:['Not Ordered', 'Partially Ordered', 'Ordered'],
            selectedStatus:null,
            orders:[],
            filteredOrders:[],
            uploadComponent:false,
            poNo:null,
            poId:null,
            loading1:false,
            refRocs:[],
            deleteFileDialog:false,
            fileDoc:null,
            docDeleteProcessing:false,
            deleteFileHeader:null,
            orderItems:[],
            loading2:false,
            itemId:null,
            visible:false,
            dialogHeader:null,
            itemDeliveryLocations:[],
            oldLocation:null,
            newQuantity:0,
            deliveredStockHeader:null,
            changeDeliveryLocationDialog:false,
            dbLocations:[],
            newLocation:null,
            reLocateRemarks:null,
            itemsWithoutLocation:[],
            itemsComponentKey:0,
            ordersComponentKey:0,
            itemsWithoutLocationKey:0,
            loading3:false,
        }
    },
    methods:{
        async getOrders(){
            
            this.loading1 = true;
            try {
                const response = await deptOrders([]);
                
                this.orders = response.data;
                this.filteredOrders = response.data;
                this.loading1 = false;
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.loading1 = false;
            }

        },
        filterOrders(){
            
            this.filteredOrders = [];
            if(this.selectedStatus==null && this.selectedFy==null && this.queryText==null && this.poDate==null){
                return this.filteredOrders = this.orders
            }

            const [fyStart, fyEnd] = this.selectedFy ?  this.selectedFy.split('-') : [];
            const fy1 = new Date(fyStart, 3, 1);
            const fy2 = new Date(fyEnd, 2, 31);         

            this.orders.forEach((e) => {
                
                const [day, month, year] = e.date.split('-');
                const poDate2 = new Date(year, month - 1, day);
                
                if((this.selectedStatus? this.selectedStatus==e.order_status : true) 
                && (this.selectedFy ? (poDate2 >= fy1 && poDate2 <= fy2) : true) 
                && (this.queryText ? (e.poNo.includes(this.queryText) || e.poNo.includes(this.queryText.toUpperCase()) || e.poNo.includes(this.queryText.toLowerCase()) || (e.department.includes(this.queryText) || e.department.includes(this.queryText.toLowerCase()) || e.department.includes(this.queryText.toUpperCase()))) : true) 
                && ((this.poDate && this.poDate[0] && this.poDate[1]) ? (poDate2 >= this.poDate[0] && poDate2 <= this.poDate[1]) : true)
                ){
                    this.filteredOrders.push(e);
                }
                
            });
            
        },
        showRefRocOp(event, data){            
            this.refRocs = []
            this.refRocs = [...data]
            this.$refs.opRefRoc.toggle(event);
        },
        statusSeverity(status) {
            switch(status) {
                case 'Not Ordered':
                    return 'danger';
                case 'Partially Ordered':
                    return 'warning';
                case 'Ordered':
                    return 'success';
                default:
                    return null;
            }
        },
        async fetchData(event){

            
            if(event.index==1){
                    this.itemsComponentKey++;
            }
            if(event.index==2){
                    this.itemsWithoutLocationKey++;
            }
            
        },
        
        
        setDeptPoStore(data){
            const store = useDeptPoStore();
            store.$patch({
                data:data,
            });
            this.$router.push('add-dept-po');
        },
        
        formatNumber(value) {
                return value.toLocaleString('en-IN', {maximumFractionDigits:4, minimumFractionDigits:2});
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        exportOrders(){
            this.$refs.ordersTable.exportCSV();
        }
    },
    mounted(){
        this.getOrders(); 
        
        // this.ordersComponentKey++;       
    }

}
</script>

<style>

</style>